const { createSelector } = require('reselect')

const selectProfile = state => state['marketplace.customerProfile'].profile

const profile = () => createSelector(
  [selectProfile],
  prof => prof.data,
)

const profileError = () => createSelector(
  [selectProfile],
  prof => prof.error,
)

const profileLoading = () => createSelector(
  [selectProfile],
  prof => prof.loading,
)

const selectProfileUpdate = state => state['marketplace.customerProfile'].update

const updateProfile = () => createSelector(
  [selectProfileUpdate],
  upd => upd.data,
)

const updateProfileError = () => createSelector(
  [selectProfileUpdate],
  upd => upd.error,
)

const updateProfileLoading = () => createSelector(
  [selectProfileUpdate],
  upd => upd.loading,
)

module.exports = {
  profile,
  profileError,
  profileLoading,
  updateProfile,
  updateProfileError,
  updateProfileLoading
}
